import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { FC } from 'react';

const LeaveFormSaveDialog: FC<any> = ({
  open,
  onClose,
  onAccept,
  onReject,
  dialogMessage = 'Changes have been made. Would you like to save the changes?',
  okButtonText = 'Save changes',
  cancelButtonText = 'Dismiss changes',
}) => {
  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      open={open}
      onClose={onClose}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button size="large" onClick={onReject}>
          {cancelButtonText}
        </Button>
        <Button autoFocus size="large" variant="contained" onClick={onAccept}>
          {okButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveFormSaveDialog;
